import { useApartmentListForCourse } from "../../assets/api/useAdminApi";
import CommonTermAndCondtion from "../commonfile/CommonTermAndCondtion";



const AdminTCList = () => {
    const { data: apartmentList, isLoading: isLoadingApartmentList } = useApartmentListForCourse();
    return (

        <CommonTermAndCondtion apartmentRow={apartmentList?.data} isloadingApartment={isLoadingApartmentList} />
    )
}

export default AdminTCList